function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(300,300)"
}, React.createElement("path", {
  d: "M166.9,-118.1C208.2,-81.3,227.9,-12.4,213.2,47.3C198.5,107.1,149.4,157.6,88.1,189.6C26.9,221.6,-46.4,235.2,-90.8,206.8C-135.1,178.4,-150.4,108.1,-162.1,41.4C-173.8,-25.3,-181.9,-88.4,-154.3,-122C-126.7,-155.7,-63.3,-159.8,-0.3,-159.6C62.8,-159.4,125.6,-154.8,166.9,-118.1Z",
  fill: "#6c63ff"
}));

var SvgBlob = function SvgBlob(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBlob, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blob.39c53a9d.svg";
export { ForwardRef as ReactComponent };